/* eslint-disable import/no-cycle */
import { takeLatest, put, all } from 'redux-saga/effects'
import qs from 'qs'
import { Types } from '../ducks/comercial'
import { graphClient } from './auth'
import { notifyError } from '../../utils/notify'
import oikosApi from '../../services/oikos'
import { history } from '../index'

// function* listContracts() {
//   try {
//     const siteId = 'root'
//     const listId = 'Contratos'
//     const endpoint = `sites/${siteId}/lists/${listId}/items?filter=fields/Status ne 'null'&expand=fields(select=
//       id,
//       Title,
//       C_x00f3_digodoProjeto,
//       N_x00fa_merodoContrato,
//       Servi_x00e7_os,
//       Setor_x0020_de_x0020_Atua_x00e7_,
//       Cliente,
//       TipodeCliente,
//       ValordoContrato,
//       DatadeAssinatura,
//       Data_x0020_da_x0020_Proposta,
//       FimdaVig_x00ea_ncia,
//       EquipeInterna,
//       CountryOrRegion,
//       State,
//       City,
//       GeoLoc,
//       Status,
//       Descritivodoacordocomercial,
//       Contato_x0020_do_x0020_Cliente,
//       Contato_x0020_do_x0020_Cliente_x,
//       Contato_x0020_do_x0020_Cliente_x0
//     )`
//     const res = yield graphClient.api(endpoint).header('Prefer', 'allowthrottleablequeries').get()
//     console.tron.log('res.value listContracts', res.value)

//     yield put({
//       type: Types.LIST_CONTRACTS_SUCCEEDED,
//       payload: res.value,
//     })
//   } catch (err) {
//     console.tron.log('Não foi possível listar os contratos.', err)
//     notifyError('Não foi possível listar os contratos.')
//     yield put({
//       type: Types.LIST_CONTRACTS_FAILED,
//     })
//   }
// }

function* listProposals() {
  try {
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
    const endpoint = `sites/${siteId}/lists/${listId}/items?expand=
      fields(select=id,Title,w7nx,Status0,Status,Valor,Setores,zlir,
        N_x00fa_meroSEGI,Cliente, Servi_x00e7_o,
        Local_x0020_de_x0020_Execu_x00e7, Prazo_x0020_de_x0020_execu_x00e7,
        Validade_x0020_da_x0020_Proposta)
      &top=9999
      &filter=fields/Status ne 'Descartado' and fields/Status ne 'Perdido'`

    const res = yield graphClient
      .api(endpoint)
      .header('Prefer', 'HonorNonIndexedQueriesWarningMayFailRandomly')
      .get()

    console.tron.log('lista propostas comerciais sharepoint res.value', res.value)

    yield put({
      type: Types.LIST_PROPOSALS_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log('Não foi possível listar as propostas comerciais.', err)
    notifyError('Não foi possível listar as propostas comerciais.')
    yield put({
      type: Types.LIST_PROPOSALS_FAILED,
    })
  }
}

function* listOportunities() {
  try {
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '88160dfe-97cb-4e7e-bf0e-46e53deba957'
    const endpoint = `sites/${siteId}/lists/${listId}/items?expand=
      fields
      &top=9999
      &filter=fields/Status eq 'Em análise'`

    const res = yield graphClient
      .api(endpoint)
      .header('Prefer', 'HonorNonIndexedQueriesWarningMayFailRandomly')
      .get()

    console.tron.log('lista pedidos de orçamento sharepoint res.value', res.value)

    yield put({
      type: Types.LIST_OPORTUNITIES_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log('Não foi possível listar as propostas comerciais.', err)
    notifyError('Não foi possível listar as propostas comerciais.')
    yield put({
      type: Types.LIST_OPORTUNITIES_FAILED,
    })
  }
}

function* listBids() {
  try {
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,32cf4926-8ed5-475c-918f-6b48d3e42b49'
    const listId = 'df3f359b-f817-44b5-a140-e384223bf177'
    /* const endpoint = `sites/${siteId}/lists/${listId}/items?
      top=9999
      &expand=fields
      &filter=fields/Participar eq 'Sim'` */
    const endpoint = `sites/${siteId}/lists/${listId}/items?
      top=9999
      &expand=fields
      &filter=fields/Participar ne 'Não'`

    const res = yield graphClient
      .api(endpoint)
      .header('Prefer', 'HonorNonIndexedQueriesWarningMayFailRandomly')
      .get()

    console.tron.log('lista licitações sharepoint res.value', res.value)

    yield put({
      type: Types.LIST_BIDS_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log('Não foi possível listar as licitações.', err)
    notifyError('Não foi possível listar as licitações.')
    yield put({
      type: Types.LIST_BIDS_FAILED,
    })
  }
}

function* getProposal(action) {
  try {
    const proposalId = action.payload
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
    /* const endpoint = `sites/${siteId}/lists/${listId}/items/${proposalId}?expand=fields(select=
      id,
      Title,
      N_x00fa_meroSEGI,
      C_x00f3_digo_x0020_Proposta,
      DataEntrada,
      Valor,
      Proced_x00ea_ncia,
      Setores,
      Status,
      Status0,
      Cliente,
      Contato_x0020_da_x0020_Empresa,
      Contato_x0020_da_x0020_Empresa_x,
      Contato_x0020_da_x0020_Empresa_x0,
      Contato_x0020_da_x0020_Empresa_x1,
      Servi_x00e7_o,
      Datacontratada
    )` */
    const endpoint = `sites/${siteId}/lists/${listId}/items/${proposalId}?expand=fields`
    const res = yield graphClient
      .api(endpoint)
      .header('Prefer', 'allowthrottleablequeries')
      .get()

    console.tron.log('getProposal res', res)

    yield put({
      type: Types.GET_PROPOSAL_SUCCEEDED,
      payload: res,
    })
  } catch (err) {
    console.tron.log('Não foi possível obter esta proposta comercial.', err)
    notifyError('Não foi possível obter esta proposta comercial.')
    yield put({ type: Types.GET_PROPOSAL_FAILED })
  }
}

function* getOportunity(action) {
  try {
    const oportunityId = action.payload
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '88160dfe-97cb-4e7e-bf0e-46e53deba957'
    const endpoint = `sites/${siteId}/lists/${listId}/items/${oportunityId}?expand=fields`
    const res = yield graphClient
      .api(endpoint)
      .header('Prefer', 'allowthrottleablequeries')
      .get()

    console.tron.log('getOportunity res', res)

    yield put({
      type: Types.GET_OPORTUNITY_SUCCEEDED,
      payload: res,
    })
  } catch (err) {
    console.tron.log('Não foi possível obter esta proposta comercial.', err)
    notifyError('Não foi possível obter esta proposta comercial.')
    yield put({ type: Types.GET_OPORTUNITY_FAILED })
  }
}

function* getLegalEntities() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'pj',
      action: 'get',
    })
    console.tron.log('res getLegalEntities', res)

    yield put({ type: Types.GET_LEGAL_ENTITIES_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_LEGAL_ENTITIES_FAILED', err)
    notifyError('Não foi possível listar as Pessoas Jurídicas.')
    yield put({ type: Types.GET_LEGAL_ENTITIES_FAILED, payload: err })
  }
}

function* getDraftContracts() {
  try {
    const res = yield oikosApi.get('/', {
      table: 'minuta',
      action: 'get',
    })
    console.tron.log('res getDraftContracts', res)

    yield put({ type: Types.GET_DRAFT_CONTRACTS_SUCCEEDED, payload: res.data })
  } catch (err) {
    console.tron.log('GET_DRAFT_CONTRACTS_FAILED', err)
    notifyError('Não foi possível listar as minutas de contrato.')
    yield put({ type: Types.GET_DRAFT_CONTRACTS_FAILED, payload: err })
  }
}

function* getDraftContract(action) {
  try {
    const id = action.payload

    const resDraftContract = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'minuta',
      data: {
        minuta_id: id,
      },
    })}`)
    console.tron.log('getDraftContract resDraftContract.data[0]', resDraftContract.data[0])

    const resDocumentVinculation = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabRef: 'minuta',
        documentoVinc_tabId: resDraftContract.data[0].minuta_id,
      },
    })}`)
    console.tron.log('getDraftContract resDocumentVinculation.data[0]', resDocumentVinculation.data[0])

    const resDraftContractFile = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'arquivo',
      data: {
        arquivo_tabRef: 'documento',
        arquivo_tabId: resDocumentVinculation.data[0].documento_id,
      },
    })}`)
    console.tron.log('getDraftContract resDraftContractFile.data[0]', resDraftContractFile.data[0])

    // const resFiles = yield oikosApi.get(`/?${qs.stringify({
    //   action: 'get',
    //   table: 'arquivo',
    //   data: `arquivo_tabRef = 'documento' AND arquivo_tabId IN (SELECT documento_id FROM documentoVinc WHERE documentoVinc_tabRef = 'minuta' AND documentoVinc_tabId = ${id}) AND arquivo_ativo = 1`,
    // })}`)
    // console.tron.log('getDraftContract resFiles', resFiles)

    const draftContract = {
      ...resDraftContract.data[0],
      file: resDraftContractFile.data[0],
    }
    console.tron.log('draftContract', draftContract)

    yield put({
      type: Types.GET_DRAFT_CONTRACT_SUCCEEDED,
      payload: draftContract,
    })
  } catch (err) {
    console.tron.log('GET_DRAFT_CONTRACT_FAILED', err.toString())
    notifyError('Não foi possível carregar a minuta de contrato.')
    yield put({ type: Types.GET_DRAFT_CONTRACT_FAILED, payload: err.toString() })
  }
}

function* getContract(action) {
  try {
    const id = action.payload

    const resContract = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrato',
      data: {
        contrato_id: id,
      },
      fields: {
        '(SELECT proj_id FROM proj WHERE proj.contrato_id = contrato.contrato_id)': 'proj_id',
      }
    })}`)
    console.log('getContract resContract', resContract)

    const resDocumentVinculation = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabRef: 'contrato',
        documentoVinc_tabId: id,
      },
      fields: {
        '(SELECT documento_desc FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_desc',
        '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1))': 'tpDocumento_desc',
        '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id)': 'arquivo_caminho',
        '(SELECT documento_ativo FROM documento WHERE documento.documento_id = documentoVinc.documento_id)': 'documento_ativo',
       },
    })}`)

    const resDocumentVinculationActive = resDocumentVinculation.data.filter(doc => doc.documento_ativo === 1);

    console.log(resDocumentVinculationActive)
/*
    yield Promise.all(resDocumentVinculation.data.map(item => {
      var aux_file = oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'arquivo',
        data: {
          arquivo_tabRef: 'documento',
          arquivo_tabId: resDocumentVinculation.data[0].documento_id,
        },
        fields: {
         '(SELECT documento_desc FROM documento WHERE documento.documento_id = arquivo.arquivo_tabId LIMIT 1)': 'documento_desc',
         '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = arquivo.arquivo_tabId LIMIT 1))': 'tpDocumento_id',
        },
      })}`)
      console.log(aux_file)
      }))
      const resContractFile = yield oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'arquivo',
        data: {
          arquivo_tabRef: 'documento',
          arquivo_tabId: resDocumentVinculation.data[0].documento_id,
        },
        fields: {
         '(SELECT documento_desc FROM documento WHERE documento.documento_id = arquivo.arquivo_tabId LIMIT 1)': 'documento_desc',
         '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = arquivo.arquivo_tabId LIMIT 1))': 'tpDocumento_id',
        },
      })}`)
*/

    if (resContract.data.length < 1) {
      throw new Error('Contrato não encontrado.')
    }

    const resProducts = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contratoProd',
      data: {
        contrato_id: resContract.data[0].contrato_id,
        contratoProd_ativo: 1,
      },
    })}`)
    console.log('getContract resProducts', resProducts)

    const resPaymentEvents = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contratoEP',
      data: {
        contrato_id: resContract.data[0].contrato_id,
        contratoEP_ativo: 1,
      },
    })}`)
    console.log('getContract resPaymentEvents', resPaymentEvents)

    const resAddendums = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrato',
      data: {
        contrato_original: resContract.data[0].contrato_id,
        contrato_ativo: 1,
      },
      fields: {
        '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_ativo = 1 AND arquivo.arquivo_tabId = (SELECT documento_id FROM documentoVinc WHERE documentoVinc.documentoVinc_tabRef = "contrato" AND documentoVinc.documentoVinc_tabId = contrato.contrato_id AND (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id) = 6 ORDER BY documento_id DESC LIMIT 1) LIMIT 1)': 'arquivo_caminho',
        '(SELECT contratoAlterTp_desc FROM contratoAlterTp WHERE contratoAlterTp.contratoAlterTp_id = contrato.contratoAlterTp_id)': 'contratoAlterTp_desc'
      }
    })}`)
    console.log('getContract resAddendums', resAddendums)

    const contract = {
      ...resContract.data[0],
      products: resProducts.data,
      paymentEvents: resPaymentEvents.data,
      files: resDocumentVinculationActive,
      addendums: resAddendums.data,
    }

    yield put({
      type: Types.GET_CONTRACT_SUCCEEDED,
      payload: contract,
    })
  } catch (err) {
    console.log('GET_CONTRACT_FAILED', err.toString())
    notifyError(err.toString())
    yield put({ type: Types.GET_CONTRACT_FAILED, payload: err.toString() })
    history.push('/')
  }
}

function* getContracts() {
  try {
    const [resContracts, resPj] = yield all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'contrato',
        data: {
          contrato_ativo: 1,
        },
        fields: {
          '(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_razaosocial',
          '(SELECT pj_nomeFanta FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_nomeFanta',
          '(SELECT minuta.minuta_SPList FROM minuta WHERE minuta.minuta_id = contrato.minuta_id)': 'minuta_SPList',
          '(SELECT minuta.minuta_SPId FROM minuta WHERE minuta.minuta_id = contrato.minuta_id)': 'minuta_SPId',
          '(SELECT areaAtua_area FROM areaAtua WHERE areaAtua_id = (SELECT areaAtua_id FROM pj WHERE pj.pj_id = contrato.contrato_contratante))': 'areaAtua_area',
        },
      })}`),
      oikosApi.get('/', { table: 'pj', action: 'get' }),
    ])
    console.tron.log('getContracts resContracts', resContracts)

    const pjById = (resPj.data || []).reduce((acc, pj) => {
      acc[pj.pj_id] = pj
      return acc
    }, {})

    const contracts = (resContracts.data || []).map(contract => {
      const contratante = pjById[contract.contrato_contratante]
      return {
        ...contract,
        pj_razaosocial: contract.pj_razaosocial || contratante?.pj_razaosocial,
        pj_nomefanta: contract.pj_nomefanta || contract.pj_nomeFanta || contratante?.pj_nomefanta || contratante?.pj_nomeFanta,
        pj_nomeFanta: contract.pj_nomeFanta || contract.pj_nomefanta || contratante?.pj_nomeFanta || contratante?.pj_nomefanta,
        clientType: contract?.minuta_SPList?.substring(39, 55) === 'comercialprivado' ? 'Privado' : 'Público',
      }
    })

    yield put({
      type: Types.GET_CONTRACTS_SUCCEEDED,
      payload: contracts,
    })
  } catch (err) {
    console.tron.log('GET_CONTRACTS_FAILED', err.toString())
    notifyError(err.toString())
    yield put({ type: Types.GET_CONTRACTS_FAILED, payload: err.toString() })
    history.push('/')
  }
}

export const comercialSagas = [
  // takeLatest(Types.LIST_CONTRACTS_REQUESTED, listContracts),
  takeLatest(Types.LIST_PROPOSALS_REQUESTED, listProposals),
  takeLatest(Types.LIST_OPORTUNITIES_REQUESTED, listOportunities),
  takeLatest(Types.LIST_BIDS_REQUESTED, listBids),
  takeLatest(Types.GET_PROPOSAL_REQUESTED, getProposal),
  takeLatest(Types.GET_OPORTUNITY_REQUESTED, getOportunity),
  takeLatest(Types.GET_LEGAL_ENTITIES_REQUESTED, getLegalEntities),
  takeLatest(Types.GET_DRAFT_CONTRACTS_REQUESTED, getDraftContracts),
  takeLatest(Types.GET_DRAFT_CONTRACT_REQUESTED, getDraftContract),
  takeLatest(Types.GET_CONTRACT_REQUESTED, getContract),
  takeLatest(Types.GET_CONTRACTS_REQUESTED, getContracts),
]
